import { SyncOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { PermissionContext } from 'components/Global/AuthLayout';
import Buttons from 'components/Global/Buttons';
import { useContext } from 'react';
import styles from './index.module.scss';

type headerProps = {
	sidebarDrawerOpen: () => void;
	isLoading: boolean;
	fetchPersonalLevyData:any;
};

const PersonalLevyHeader = ({
	sidebarDrawerOpen,
	isLoading,
	fetchPersonalLevyData
}: headerProps) => {
	const permissionContext = useContext(PermissionContext);
	const isAdd = permissionContext.allowedPermissions.includes(
		'Add_Statutory_Components'
	);
	const buttonTitle = 'Add Personal Levy';
	const buttons = [
		{
			text: buttonTitle,
			isLoading: false,
			className: 'btn-blue',
			isSubmit: true,
			onclick: () => {
				sidebarDrawerOpen();
			},
			disabled: isLoading,
		},
	];
	return (
		<div className={styles['others-header']}>
			<p>Personal Levy</p>
			{isAdd && (
				<div className={styles['others-header__buttons']}>
					<Tooltip title="Refresh all the Personal Levy">
						<SyncOutlined
							style={{
								fontSize: '20px',
								cursor: isLoading ? 'not-allowed' : 'pointer',
								color: '#584495',
								transition: 'transform 0.3s',
								marginRight: '10px',
							}}
							onClick={
								!isLoading ? fetchPersonalLevyData : undefined
							}
						/>
					</Tooltip>
					<Buttons buttons={buttons} />
				</div>
			)}
		</div>
	);
};

export default PersonalLevyHeader;
